export default __webpack_public_path__ + "static/media/AE7.f5ade3ef.jpg";